const appendElements = (elementList) => (container) => {
    elementList.forEach((el) => container.appendChild(el));
    return container;
};

export default appendElements;
